import * as createStore from './createStore';
import * as reducer from './reducer'
import * as asyncMiddleware from './asyncMiddleware'
import * as render from './render'
import * as preload from './preload';

module.exports = {
  ...createStore,
  ...reducer,
  ...asyncMiddleware,
  ...render,
  ...preload
}




// WEBPACK FOOTER //
// ../~/shared/src/utils/redux/index.js